import React from 'react'
import { Table } from 'react-bootstrap'
import RowTableDocentes from './RowTableDocentes'
import Pagination from '../../shared/Pagination'
import Skeleton from 'react-loading-skeleton'

const TableTeachers = ({
    teachers,
    getTeachers,
    pagination,
    enableTeacher,
    countSchedules,
    loadingTeachers,
    handleAction,
}) => {
    const handlePage = (page, pageSize) => {
        getTeachers(page, pageSize)
    }

    return (
        <div className='contenedor'>
            <div className='fs-3 mb-3'>Docentes</div>
            <Table>
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Correo</th>
                        <th>C.I.</th>
                        <th className='text-center'>Horarios habilitados</th>
                        <th className='text-center'>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {teachers?.length > 0 ? (
                        teachers.map((teacher, index) => (
                            <RowTableDocentes
                                key={teacher.ci}
                                teacher={teacher}
                                enableTeacher={enableTeacher}
                                schedulesCount={countSchedules[index]}
                                handleAction={handleAction}
                            />
                        ))
                    ) : (
                        <tr style={{ textAlign: 'center' }}>
                            <td colSpan={5}>
                                {loadingTeachers ? <Skeleton count={4} height={40} /> : 'No existen docentes'}
                            </td>
                        </tr>
                    )}
                    <tr>
                        <td colSpan={5}>
                            {teachers?.length > 0 && (
                                <Pagination
                                    totalRecords={pagination.totalRecords}
                                    rowsPerPage={pagination.pageSize}
                                    rowsPerPageOptions={[10, 25, 50]}
                                    page={pagination.currentPage}
                                    onPage={handlePage}
                                    paginationReport={`Mostrando ${pagination.offset + 1}-${
                                        pagination.offset + teachers.length
                                    } de ${pagination.totalRecords} items.`}
                                />
                            )}
                        </td>
                    </tr>
                </tbody>
            </Table>
        </div>
    )
}

export default TableTeachers
